export default __webpack_public_path__ + "static/media/logo6.019d34bd.webp";